import React, { useCallback } from "react";
import classnames from "classnames";

import { TableProperty } from "../interface";
import "./index.scss";

export interface RowProps<T> {
  item: T;
  properties: TableProperty<T>[];
  onClick?: () => void;
}

function getItemCellContent<T>(item: T, prop: TableProperty<T>) {
  return prop.get ? prop.get(item) : item[prop.key];
}

function Row<T>(props: RowProps<T>) {
  const { properties, item, onClick } = props;

  const localCellClick = useCallback(
    (property: TableProperty<T>, event: React.MouseEvent) => {
      if (!property.cellClick) {
        return;
      }

      event.stopPropagation();
      event.preventDefault();

      property.cellClick(item);
    },
    [item],
  );

  return (
    <div className="table-row" onClick={onClick}>
      {properties.map((prop, index) => (
        <React.Fragment key={index}>
          {prop.appearClickBlock ? (
            <div
              key={`${index}_${prop.key.toString()}`}
              className="table-row-cell-clickblock appear-click-block"
              onClick={(e) => localCellClick(prop, e)}>
              {prop.appearClickBlock(item)}
            </div>
          ) : (
            <div
              key={prop.title}
              className={classnames("table-row-cell", prop.cellClassName)}
              onClick={prop.cellWholeClick ? (e) => localCellClick(prop, e) : undefined}>
              {getItemCellContent<T>(item, prop)}
              {prop.cellClickBlock && (
                <div className="table-row-cell-clickblock" onClick={(e) => localCellClick(prop, e)}>
                  {prop.cellClickBlock}
                </div>
              )}
            </div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
}

export default Row;
